import Setair from '@assets/images/Setair.png';
import Seturbiz from '@assets/images/seturbiz.png';
import SeturCruise from '@assets/images/seturcruise.png';
import SeturDutyFree from '@assets/images/seturdutyfree.png';
import SeturHealth from '@assets/images/SeturHealth.png';
import SeturMice from '@assets/images/seturmice.png';
import SeturSelect from '@assets/images/seturselect.png';
import Instagram from '@assets/images/IG.png';
import Facebook from '@assets/images/FB.png';
import Youtube from '@assets/images/Youtube.png';
import SeturX from '@assets/images/X.png';
import Linkedin from '@assets/images/Linkedin.png';

export const makeAbsoluteLink = (url = '') =>
  /^\//.test(url) ? url : `/${url}`;

export const Logo = [
  {
    image: SeturDutyFree,
    alt: 'SeturDutyFree',
    href: 'https://www.setur.com.tr/siteler/setur-duty-free',
    width: '129px', // Static width added
    height: '20px',
    styles: {
      marginBottom: '-2px',
    },
  },
  {
    image: Seturbiz,
    alt: 'Seturbiz',
    href: 'https://www.setur.com.tr/siteler/seturbiz',
    width: '84px', // Static width added
    height: '18px',
  },
  {
    image: SeturMice,
    alt: 'SeturMice',
    href: 'https://www.seturmice.com',
    width: '93px', // Static width added
    height: '18px',
  },
  {
    image: SeturCruise,
    alt: 'SeturCruise',
    href: 'https://www.setur.com.tr/siteler/setur-cruise',
    width: '117px', // Static width added
    height: '18px',
  },
  {
    image: Setair,
    alt: 'Setair',
    href: 'https://www.setur.com.tr/siteler/setair',
    width: '61px', // Static width added
    height: '18px',
  },
  {
    image: SeturSelect,
    alt: 'SeturSelect',
    href: 'https://www.select-tours.com/en',
    width: '50px', // Static width added
    height: '20px',
    styles: {
      marginBottom: '0.5px',
    },
  },
  {
    image: SeturHealth,
    alt: 'SeturHealth',
    href: 'https://www.seturhealth.com/en/',
    width: '122px', // Static width added
    height: '20px',
  },
];
export const socialMediaImage = [
  {
    image: Instagram,
    alt: 'Setur Instagram',
    href: 'https://www.instagram.com/setur/',
  },
  {
    image: Facebook,
    alt: 'Setur Facebook',
    href: 'https://www.facebook.com/setur/',
  },
  {
    image: Youtube,
    alt: 'Setur Youtube',
    href: 'https://www.youtube.com/setur',
  },
  { image: SeturX, alt: 'Setur X', href: 'https://x.com/setur' },
  {
    image: Linkedin,
    alt: 'Setur Linkedin',
    href: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFQaUraHJldNgAAAZPjTVtwgV-psxKxYseamR3c-fskYYgugewaYLBSG8ZJeWLQAxNv3s8ssDcJawPA60Kc33HZHBhCvYBR3GIPMznn6wVsoWFpcCWGv0UNnMpHe588v_lTvZg=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fsetur%2F',
  },
];
